{
	"after_call": "After the call",
	"category": {
		"doctoral_and_specialization": "Doctoral and specialization",
		"first_year": "First year",
		"later_years": "Later years",
		"unknown": "To be defined"
	},
	"columns": {
		"category": "Category",
		"criterion": "Criterion",
		"effective": "Counts from",
		"flags": "Flags",
		"name": "Surname and name",
		"origin": "Origin",
		"protocol": "Prot.",
		"quotas": "Quotas",
		"state": "State"
	},
	"correction": {
		"after": "After",
		"back": "Back to the fields",
		"before": "Before",
		"description": "Change only the fields transcribed wrongly. Every change stays in the history with the previous value, and the requirements are evaluated again on the new data.",
		"field": "Field",
		"no_changes": "No field has changed.",
		"not_allowed_description": "Only applications received by direct PEC and still valid can be corrected.",
		"not_allowed_title": "This application cannot be corrected",
		"page_title": "Correct transcription",
		"review": "Review the changes",
		"review_title": "Changes to save",
		"save": "Save the correction",
		"saved": "Correction saved",
		"tax_code_locked": "The tax code is not corrected: a different code is another person, so another application to upload."
	},
	"criterion": {
		"credits": "{{value}} credits",
		"iseeu": "ISEEU {{value}}"
	},
	"detail": {
		"breadcrumb": "Application",
		"changed": {
			"refresh": "Refresh",
			"submitted": "The application changed after you opened this page: the data below is what it was.",
			"superseded": "The application was replaced by a newer one after you opened this page: the data below is what it was.",
			"withdrawn": "The application was withdrawn after you opened this page: the data below is what it was."
		},
		"course_type": {
			"bachelor": "Bachelor's degree",
			"master": "Master's degree",
			"phd": "Doctorate",
			"single_cycle": "Single-cycle master's degree",
			"specialization": "Specialization school"
		},
		"declaration_made": "Made on {{date}}",
		"declaration_missing": "Not made yet",
		"declarations_made": "Made at signing, on {{date}}",
		"direct": {
			"arrived_at": "Arrived on",
			"by_at": "{{name}}, {{when}}",
			"correct": "Correct transcription",
			"corrections": "Transcription corrections",
			"email_reply": "Confirmation email sent automatically",
			"message": "Original message",
			"message_kind": {
				"eml": ".eml file",
				"pdf": "PDF"
			},
			"pec_reply": "Reply to the sender",
			"pec_reply_pending": "To send from the PEC of the residence",
			"pec_reply_sent": "Sent from the PEC on {{when}}",
			"section": "Received by direct PEC",
			"sender": "Sender",
			"unknown_author": "Removed account",
			"uploaded": "Uploaded by"
		},
		"fields": {
			"birth_date": "Date of birth",
			"birth_place": "Place of birth",
			"campus": "Campus",
			"campus_address": "Address of the teaching site",
			"category": "Category",
			"course_name": "Name of the course",
			"course_type": "Course type",
			"credits": "Credits earned",
			"effective": "Counts from",
			"email": "Email of the application",
			"enrollment_year": "Year of enrolment",
			"exclude_q70": "Excluded from quota 70%",
			"first_name": "Name",
			"grade_average": "Average of the grades",
			"institution": "University",
			"iseeu": "ISEEU",
			"ispeu": "ISPEU",
			"last_name": "Surname",
			"needs_equipped": "Equipped room",
			"no": "No",
			"none": "None",
			"not_given": "Not given",
			"passport": "Passport",
			"phone": "Phone",
			"pre_enrollment_number": "Pre-enrolment number",
			"protocol": "Protocol",
			"quotas": "Quotas",
			"residence": "Residence",
			"room_preference": "Room preference",
			"student_number": "Student number",
			"tax_code": "Tax code",
			"warnings": "Requirements not met",
			"yes": "Yes"
		},
		"not_found": "Application not found",
		"room": {
			"double": "Double room",
			"none": "No preference",
			"single": "Single room"
		},
		"sections": {
			"declarations": "Declarations",
			"economic": "Economic situation",
			"enrollment": "Enrolment",
			"files": "Files sent",
			"flags": "Requirement flags",
			"history": "History",
			"preferences": "Preferences and requirements",
			"student": "Applicant"
		},
		"superseded_note": "Replaced by application no. {{protocol}}",
		"title": "Application no. {{protocol}}",
		"warning": {
			"cfu_below_min": "Credits below the minimum of the call",
			"iseeu_above": "ISEEU above the threshold of the call",
			"ispeu_above": "ISPEU above the threshold of the call",
			"offsite_not_met": "Off-site requirement not met"
		},
		"withdrawn_elsewhere_note": "Withdrawn on {{date}}: accepted a place in another residence",
		"withdrawn_note": "Withdrawn on {{date}}"
	},
	"disability_priority": {
		"cause": "Disability documentation missing or not valid",
		"cause_label": "Cause:",
		"confirm": "Remove the priority",
		"dialog_description": "The application goes back to its normal place. If that place gives it the same seat, the offer stays, even if already accepted; otherwise the seat goes to the next student in the ranking. The student gets an email with the cause.",
		"dialog_title": "Remove the disability priority?",
		"done": "Priority removed: the ranking is recalculated shortly.",
		"held": "The application got an equipped place with the disability priority. Check the disability document among the files: if it is missing or not valid, remove the priority.",
		"note": "Note for the student (optional)",
		"restore": "Give the disability priority back",
		"restore_confirm": "Give the priority back",
		"restore_description": "The ranking is recalculated with the priority. A seat already offered to another student is not taken back: the application gets a seat with the priority only if one is still free.",
		"restore_reason": "Reason",
		"restore_reason_hint": "For example: removed by mistake, or the document is valid. It stays in the log.",
		"restore_title": "Give the disability priority back?",
		"restored": "Priority given back: the ranking is recalculated shortly.",
		"revoke": "Remove the disability priority",
		"revoked": "The disability priority was removed: the application stays in the ranking at its normal place. If it was a mistake, or the document turned out valid, give the priority back.",
		"title": "Disability priority"
	},
	"empty": "No application received",
	"empty_filtered": "No application with these filters",
	"files": {
		"document": {
			"credits_screenshot": "Screenshot of the exams",
			"disability": "Disability document",
			"doctoral_enrollment": "Doctoral or specialization enrolment",
			"enrollment": "University document",
			"identity": "Identity document",
			"iseeu_ispeu": "ISEEU and ISPEU certificate"
		},
		"download": "Download",
		"empty": "No file.",
		"failed": "We could not download the file. Try again.",
		"kind": {
			"annex_a": "Annex A",
			"direct_message": "Message received at the PEC",
			"document": "Document"
		},
		"platform_only": "On the platform only: not sent to the PEC of the call",
		"sha256": "SHA-256 {{value}}"
	},
	"filters": {
		"category": "Category",
		"flags": "Flags",
		"origin": "Origin",
		"quota": "Quota",
		"review": "Validity",
		"sent": "Sent",
		"state": "State",
		"with_open_flags": "With open flags"
	},
	"intake": {
		"annex_email_hint": "The email written in the Allegato A.",
		"back": "Back",
		"birth_country": "Country of birth",
		"born_abroad": "Born abroad",
		"choose": "Choose",
		"close": {
			"cancel": "Cancel",
			"command": "I have loaded every application received by PEC",
			"confirm": "Close the intake",
			"description_one": "You loaded {{count}} application received by PEC. After the closing no other can be loaded.",
			"description_other": "You loaded {{count}} applications received by PEC. After the closing no other can be loaded.",
			"done": "Intake closed",
			"title": "Close the intake"
		},
		"closed_description": "Applications can be loaded from the opening of the call until the intake closes.",
		"closed_title": "The intake of the applications received by PEC is closed",
		"command": "Load an application received by PEC",
		"country_empty": "No country found.",
		"country_placeholder": "Search the country",
		"credits_hint": "Leave empty when the Allegato A does not give them.",
		"declarations": {
			"noConvictions": "No convictions or pending charges",
			"noDebts": "No debt towards the operator",
			"noIncompatibleIllness": "No illness incompatible with community life",
			"offSite": "Declaration of being off-site"
		},
		"description": "Load an application that reached the PEC of the residence: original message, transcription of the Allegato A, check of the other applications of the same person and summary.",
		"documents": {
			"hint": "Upload the documents attached to the message and say what they are.",
			"kind": "Kind of document",
			"remove": "Remove the document",
			"too_large": "The file is larger than 10 MB.",
			"upload_failed": "We could not upload the document. Try again.",
			"wrong_type": "The file is not a PDF, a JPG or a PNG."
		},
		"duplicates": {
			"failed": "We could not read the other applications. Try again.",
			"none": "No other application with this tax code at this residence.",
			"other_counts": "Application no. {{protocol}} will count: it was sent after this one.",
			"protocol": "No. {{protocol}}",
			"rule": "Of two applications of the same person at the same residence, the one sent last before the closing of the call counts.",
			"this_counts": "This application will count: it was sent after application no. {{protocol}}."
		},
		"errors": {
			"direct_arrival_not_certified": "The PEC certifies the arrival on {{date}} at {{time}}: that is the time that counts, and it replaced yours.",
			"direct_arrived_after_close": "The PEC arrived after the closing of the call and cannot be loaded.",
			"direct_arrived_out_of_window": "The arrival is in the future or before the call opened.",
			"direct_tax_code_invalid": "Tax code not valid, or not consistent with name, surname and date of birth."
		},
		"extra_semester": "Additional semester",
		"family_abroad": "Family abroad",
		"field_errors": {
			"arrivalDate": "Write the date the PEC arrived.",
			"arrivalTime": "Write the time it arrived, Italian time.",
			"birthCountryCode": "Choose the country of birth.",
			"birthDate": "Write the date of birth.",
			"birthMunicipalityIstatCode": "Choose the municipality of birth from the list.",
			"campusAddress": "Write the street and number of the teaching site.",
			"campusCode": "Choose the campus.",
			"courseName": "Write the name of the course.",
			"courseType": "Choose the type of course.",
			"credits": "Write the credits as a whole number, or leave it empty.",
			"default": "Check this field.",
			"email": "Write a valid email address, such as name@example.com.",
			"enrollmentYear": "Choose the year of enrolment.",
			"firstName": "Write the first name as in the Allegato A.",
			"gradeAverage": "Enter the average from 18 to 30, with at most two decimals, or leave it empty.",
			"institutionCode": "Choose the university.",
			"iseeuCents": "Write the ISEEU in euro.",
			"ispeuCents": "Write the ISPEU in euro.",
			"lastName": "Write the surname as in the Allegato A.",
			"messageAssetId": "Upload the original message.",
			"phone": "Write a valid phone number.",
			"residenceAddress": "Write the address of residence.",
			"residenceCountryCode": "Choose the country of residence.",
			"residenceMunicipalityIstatCode": "Choose the municipality of residence from the list.",
			"residencePostalCode": "The postal code has 5 digits.",
			"senderAddress": "Write the address of the sender.",
			"taxCode": "The tax code has 16 characters, letters and digits."
		},
		"fix_fields": "Check the highlighted fields.",
		"grade_average_hint": "Leave it empty if the Allegato A does not state it.",
		"groups": {
			"declarations": "Declarations",
			"documents": "Documents received",
			"economic": "Economic requirements",
			"enrollment": "Enrolment",
			"person": "Personal data",
			"preferences": "Preferences",
			"residence": "Residence"
		},
		"invalid": "Value not valid.",
		"invalid_email": "Email address not valid.",
		"leave": {
			"description": "The data entered is not saved and will be lost.",
			"leave": "Leave",
			"stay": "Stay",
			"title": "Leave without registering?"
		},
		"message": {
			"arrival_date": "Date of arrival",
			"arrival_time": "Time of arrival",
			"file": "Original message",
			"file_hint": "The message as it arrived: the .eml file saved from the PEC mailbox, or the PDF.",
			"italian_time": "Italian time.",
			"kind": {
				"email": "Ordinary email sender",
				"pec": "PEC sender"
			},
			"missing": "Upload the original message.",
			"not_read": "Arrival and sender cannot be read off the message: enter them.",
			"proposed": "Arrival and sender are read off the message: check them.",
			"reading": "Reading the message",
			"sender": "Address of the sender",
			"sender_hint": "The offer, if any, goes here.",
			"sender_kind": "Kind of sender",
			"too_large": "The file is larger than 25 MB.",
			"upload_failed": "We could not upload the file. Try again.",
			"uploading": "Uploading",
			"wrong_type": "The file is neither an .eml nor a PDF."
		},
		"municipality_empty": "No municipality found.",
		"municipality_hint": "Type at least two letters of the name of the municipality.",
		"municipality_placeholder": "Search the municipality",
		"next": "Next",
		"page_title": "Load an application received by PEC",
		"passport_number": "Passport number",
		"passport_number_hint": "Only for a family abroad, when the student has no tax code.",
		"passport_of": "passport {{number}}",
		"places_required": "Give the municipality or the country of birth and of residence.",
		"postal_code": "Postal code",
		"register": "Register application",
		"registered": {
			"back": "Back to the applications",
			"born_superseded": "It does not count: application no. {{protocol}} of the same person was sent later.",
			"copied": "Text copied.",
			"copy": "Copy text",
			"counts": "The application is valid.",
			"email_sent": "The student gets an email with the transcribed data.",
			"open": "Open the application",
			"replaces": "It replaces application no. {{protocol}}, sent earlier.",
			"reply_hint": "The sender wrote from a PEC: send this text from the PEC of the residence, then mark the reply as sent.",
			"reply_marked": "Reply recorded as sent.",
			"reply_sent": "I sent the reply",
			"reply_title": "Text to send from the PEC of the residence",
			"title": "Application registered with number {{protocol}}"
		},
		"required": "Required field.",
		"residence_address": "Address of residence",
		"residence_country": "Country of residence",
		"status": {
			"declared": "Intake closed on {{date}} by {{name}}.",
			"expired": "Closed when the term ran out, on {{date}}.",
			"open_call": "You can load the applications that reached the PEC of the residence until the intake closes.",
			"open_until": "Intake open until {{date}} at 24:00.",
			"someone": "a manager"
		},
		"steps": {
			"duplicates": "Other applications of the person",
			"message": "Original message",
			"summary": "Summary",
			"transcription": "Transcription"
		},
		"summary": {
			"arrival": "Arrival of the PEC",
			"message": "Original message",
			"no_preview": "The message cannot be shown here.",
			"reviewed": "I checked the transcribed data again",
			"reviewed_required": "Confirm that you checked the data again."
		},
		"tax_code_hint": "The tax code is not corrected after the registration: check it carefully."
	},
	"notice": {
		"replacement": "Replaced: to see",
		"restored": "Valid again: to see",
		"withdrawal": "Withdrawn: to see"
	},
	"origin": {
		"direct_pec": "Received by direct PEC",
		"platform": "Platform"
	},
	"page_title": "Applications",
	"quota": {
		"none": "No quota",
		"q30": "Quota 30%",
		"q70": "Quota 70%"
	},
	"review": {
		"acknowledge": "Confirm it is valid",
		"acknowledged_at": "Confirmed valid on {{when}}",
		"acknowledged_done": "Confirmed valid. The student receives an email.",
		"already_reviewed": "This application is already confirmed valid: the page is up to date.",
		"cause": {
			"annex_mismatch": "The Allegato A is not the one generated (or the check code does not match)",
			"annex_unreadable": "The Allegato A is unreadable or incomplete",
			"identity_document_problem": "The identity document is missing or unreadable",
			"missing_signature": "The Allegato A is not signed"
		},
		"check_code": "Check code",
		"dialog_description": "Choose what is wrong. The student receives an email with the cause and can correct and send the application again until the call closes; the application stays in the ranking.",
		"dialog_title": "Report a problem in the application",
		"help": "Look in the PEC for the email with this subject, compare the check code with the one on the Allegato A and read the data. When you confirm it is valid, the student gets an email. The ranking is approved only when every application is confirmed or has a problem reported.",
		"not_delivered_note": "The email did not reach the PEC mailbox: the application is valid and you see it here. Check that the mailbox also accepts ordinary email.",
		"note": "A note for the student (optional)",
		"note_hint": "{{count}} / {{max}}",
		"problem_done": "Problem reported. The student receives an email with the cause.",
		"report": "Report a problem",
		"section": "In the PEC of the call",
		"send_problem": "Report the problem",
		"sent_at": "Sent on",
		"state": {
			"acknowledged": "Confirmed valid",
			"awaiting": "Awaiting confirmation",
			"problem": "With a problem"
		},
		"subject": "Subject of the email",
		"to": "PEC mailbox of the call"
	},
	"search_placeholder": "Search by name or protocol",
	"state": {
		"submitted": "Sent",
		"superseded": "Replaced",
		"withdrawn": "Withdrawn"
	},
	"timeline": {
		"acknowledged": "Confirmed valid",
		"problem_reported": "Problem reported to the student",
		"received_by_pec": "Received by direct PEC",
		"submitted": "Sent by the student",
		"superseded": "Replaced by a new application",
		"transcription_corrected": "Transcription corrected",
		"withdrawn": "Withdrawn by the student"
	},
	"transmission": {
		"not_delivered": "Not delivered"
	}
}
